// import React, { useState ,useEffect } from "react";
// import "./tab.css";

// const TabComponent = ({ accessibleSubjects = [], onTabChange }) => {
//   const [activeTab, setActiveTab] = useState(null);

//   useEffect(() => {
//     const firstAccessible = accessibleSubjects.find((s) => s.isAccessible);
//     if (firstAccessible && !activeTab) {
//       setActiveTab(firstAccessible.subject_name);
//       onTabChange(firstAccessible.subject_id); // send subject_id to parent
//     }
//   }, [accessibleSubjects]);

//   const handleTabClick = (subject) => {
//     if (subject.isAccessible) {
//       setActiveTab(subject.subject_name);
//       onTabChange(subject.subject_id); // notify parent of change
//     }
//   };

//   return (
//     <div className="tab-container">
//       <div className="tab-buttons">
//         {accessibleSubjects.map((subject) => (
//           <button
//             key={subject.subject_id}
//             className={`tab-button 
//               ${activeTab === subject.subject_name ? "active" : ""} 
//               ${!subject.isAccessible ? "disabled" : ""}`}
//             onClick={() => handleTabClick(subject)}
//             disabled={!subject.isAccessible}
//           >
//             {subject.subject_name.toUpperCase()}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default TabComponent;




import React, { useState, useEffect } from "react";
import "./tab.css";

const TabComponent = ({ accessibleSubjects = [], onTabChange, hasUnsavedChanges, activeSubjectId }) => {
  
  useEffect(() => {
    const firstAccessible = accessibleSubjects.find((s) => s.isAccessible);
    if (firstAccessible && !activeSubjectId) {
      onTabChange(firstAccessible.subject_id);
    }
  }, [accessibleSubjects, activeSubjectId]);

  const handleTabClick = (subject) => {
    if (!subject.isAccessible) return;

    if (hasUnsavedChanges && subject.subject_id !== activeSubjectId) {
      onTabChange(null, subject.subject_id);
    } else {
      onTabChange(subject.subject_id);
    }
  };

  return (
    <div className="tab-container">
      <div className="tab-buttons">
        {accessibleSubjects.map((subject) => (
          <button
            key={subject.subject_id}
            className={`tab-button 
              ${subject.subject_id === activeSubjectId ? "active" : ""} 
              ${!subject.isAccessible ? "disabled" : ""}`}
              onClick={() => handleTabClick(subject)}
              disabled={!subject.isAccessible}
          >
            {subject.subject_name.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabComponent;












 

// const TabComponent = ({ accessibleSubjects = [] }) => {
//   const [activeTab, setActiveTab] = useState(null);

//   useEffect(() => {
//     // Set first accessible subject as active
//     const firstAccessibleSubject = accessibleSubjects.find(subject => subject.isAccessible);
//     if (firstAccessibleSubject && !activeTab) {
//       setActiveTab(firstAccessibleSubject.subject_name);
//     }
//   }, [accessibleSubjects, activeTab]);

//   const allSubjects = ["Physics", "Chemistry", "Botany", "Zoology"];

//   return (
//     <div className="tab-container">
//       {/* Tab Navigation */}
//       <div className="tab-buttons">
//          {accessibleSubjects.map((subject) => (
//           <button
//             key={subject.subject_id}
//             className={`tab-button 
//               ${activeTab === subject.subject_name ? "active" : ""} 
//               ${!subject.isAccessible ? "disabled" : ""}`}
//             onClick={() => subject.isAccessible && setActiveTab(subject.subject_name)}
//             disabled={!subject.isAccessible}
//           >
//             {subject.subject_name.toUpperCase()}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default TabComponent;
